import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  Settings, 
  LogOut, 
  FileText, 
  CreditCard, 
  RotateCcw, 
  History, 
  Activity 
} from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { logOut } from '../../services/auth';
import styles from './Admin.module.css';

export function AdminLayout({ children }: { children: React.ReactNode }) {
  const { profile } = useAuth();
  const location = useLocation();

  const handleLogout = async () => {
    await logOut();
  };

  const navItems = [
    { path: '/admin', label: 'Overview', icon: LayoutDashboard },
    { path: '/admin/users', label: 'Users', icon: Users },
    { path: '/admin/reports', label: 'Reports', icon: FileText },
    { path: '/admin/finance', label: 'Finance', icon: CreditCard },
    { path: '/admin/refunds', label: 'Refunds', icon: RotateCcw },
    { path: '/admin/logs', label: 'Audit Logs', icon: History },
    { path: '/admin/settings', label: 'Settings', icon: Settings },
    { path: '/admin/health', label: 'System Health', icon: Activity },
  ];

  return (
    <div className={styles.adminLayout}>
      <aside className={styles.sidebar}>
        <div className={styles.sidebarHeader}>
          <h2>PCCheckr Admin</h2>
          <span className={styles.roleBadge}>{profile?.role}</span>
        </div>
        
        <nav className={styles.adminNav}>
          {navItems.map(item => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path || (item.path !== '/admin' && location.pathname.startsWith(item.path));
            return (
              <Link 
                key={item.path} 
                to={item.path} 
                className={`${styles.navItem} ${isActive ? styles.active : ''}`}
              >
                <Icon size={18} /> {item.label}
              </Link>
            );
          })}
        </nav>

        <div className={styles.sidebarFooter}>
          <button onClick={handleLogout} className={styles.logoutBtn}>
            <LogOut size={18} /> Exit Admin
          </button>
        </div>
      </aside>

      <main className={styles.adminContent}>
        {children}
      </main>
    </div>
  );
}
